<div style="margin-top: 10px;">
  @if (editableTable) {
    <form [formGroup]="editableTable">
      @if (!utilService.isMobile()) {
        <div style="margin-top: 10px;" class="col-lg-12 p-0 table-responsive">
          @if (fields) {
            <table class="base-table" [ngStyle]="{'min-width': minWidth}">
              <thead>
                <tr>
                  @if (listBlocks.selectAll) {
                    <th scope="col">
                      @if (items) {
                        <input (change)="onAllChecked($event.target.checked)"
                          [checked]="selectedCount === items.length && items.length > 0" type="checkbox"
                          class="checkbox">
                      }
                    </th>
                  }
                  @for (field of fields; track field) {
                    @if (!field.hidden) {
                      <th scope="col">
                        <span>{{ field.heading | translate | async}}</span>
                      </th>
                    }
                  }
                  @if (listBlocks.actions) {
                    <th scope="col">
                      &nbsp;
                    </th>
                  }
                </tr>
              </thead>
              @if (fields.length > 0) {
                <tbody>
                  @for (group of getFormControls.controls ; track group; let i = $index) {
                    <ng-container formArrayName="editableRows"
                      >
                      <tr [formGroupName]="i">
                        @if (listBlocks.selectAll) {
                          <td scope="row">
                            <input type="checkbox" class="checkbox"
                              (change)="onItemChecked($event.target.checked, i)" [checked]="selectedIndices[i]">
                          </td>
                        }
                        @for (field of fields; track field) {
                          @if (!field.hidden) {
                            <td scope="row" [ngStyle]="{'width':field.width}">
                              @switch (field.component) {
                                @case ('textbox') {
                                  <input type="text" [formControlName]="field.name">
                                }
                                @case ('label') {
                                  @if (field.type == undefined) {
                                    <label [controlName]="field.name"></label>
                                  }
                                  @if (field.type === 'datetime') {
                                    <span>
                                      {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateTimeFormat) : ''}}
                                    </span>
                                  }
                                  @if (field.type === 'date') {
                                    <span>
                                      {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateFormat) : ''}}
                                    </span>
                                  }
                                  @if (field.type === 'monthYear') {
                                    <span>
                                      {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) |
                                      MonthYearFormat) : ''}}
                                    </span>
                                  }
                                  @if (field.type === 'time') {
                                    <span>
                                      {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | timeFormat) : ''}}
                                    </span>
                                  }
                                }
                                @case ('numberbox') {
                                  <input type="number" [formControlName]="field.name"
                                    [min]="0" class="form-control" style="width: 100px;" [attr.step]="0"
                                    scrollOverlay>
                                }
                                @case ('textarea') {
                                  <textarea [formControlName]="field.name"
                                  class="form-control" rows="2" style="width: 200px;"></textarea>
                                }
                                @case ('dropdown') {
                                  <select [formControlName]="field.name"
                                    (change)="onDropDownChange($event, field, i)" class="form-control"
                                    width="150px">
                                    <option value="">Select</option>
                                    @if (field.options) {
                                      @for (option of field.options; track option) {
                                        <option
                                          [value]="field.getterKey ? getIdKey(option,field) : option.id">
                                          {{ field.getterValue ? getValue(option,field) : option.value }}
                                        </option>
                                      }
                                    }
                                  </select>
                                }
                                @case ('timepicker') {
                                  <dhs-timepicker [formControlName]="field.name"
                                    [timePickerSeconds]="field.timePickerSeconds"
                                    [timePicker24Hour]="field.timePicker24Hour"
                                    [timePickerIncrement]="field.timePickerIncrement" [value]="field.value">
                                  </dhs-timepicker>
                                }
                              }
                            </td>
                          }
                        }
                        @if (listBlocks.actions) {
                          <td class="tdmiddle" style="width:10%">
                            @if (listBlocks.actions.add) {
                              <span class="ca-actions pr-2" (click)="addRow(i)">
                                <span class="fa fa-plus-circle"></span>
                              </span>
                            }
                            @if (listBlocks.actions.edit) {
                              <span class="ca-actions pr-2" (click)="editRow(i)">
                                <span class="fa fa-pencil"></span>
                              </span>
                            }
                            @if (listBlocks.actions.remove) {
                              <span class="ca-actions pl-2" (click)="removeRow(i)">
                                <span class="fa fa-minus-circle"></span>
                              </span>
                            }
                          </td>
                        }
                      </tr>
                    </ng-container>
                  }
                </tbody>
              }
            </table>
          }
        </div>
      }
      @if (utilService.isMobile()) {
        <div>
          @for (group of getFormControls.controls ; track group; let i = $index) {
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 float-left card-mobile-padding" formArrayName="editableRows"
              >
              <div #commonCardLayout class="card card-view default-view no-border-card" [formGroupName]="i">
                <div class="card-top-section">
                  <div class="col-12 float-left p-top-section pl-2 pr-2 appt-card-actions">
                    <div class="d-flex" style="justify-content: flex-end;">
                      @if (listBlocks.selectAll) {
                        <div>
                          <input type="checkbox" class="checkbox"
                            (change)="onItemChecked($event.target.checked, i)"
                            [checked]="selectedIndices[i]">
                        </div>
                      }
                      @if (listBlocks.actions) {
                        <div class="d-flex">
                          @if (listBlocks.actions.add) {
                            <span class="ca-actions pr-2" (click)="addRow(i)">
                              <span class="fa fa-plus-circle"></span>
                            </span>
                          }
                          @if (listBlocks.actions.edit) {
                            <span class="ca-actions pr-2" (click)="editRow(i)">
                              <span class="fa fa-pencil"></span>
                            </span>
                          }
                          @if (listBlocks.actions.remove) {
                            <span class="ca-actions pl-2"
                              (click)="removeRow(i)">
                              <span class="fa fa-minus-circle"></span>
                            </span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="card-middle-section mb-4">
                  @for (field of fields; track field) {
                    <div class="pl-1 pr-1 mb-1">
                      @if (!field.hidden) {
                        <span>{{ field.heading | translate | async}}
                        </span>
                      }
                      @if (!field.hidden) {
                        <div>
                          @switch (field.component) {
                            @case ('textbox') {
                              <input type="text" [formControlName]="field.name">
                            }
                            @case ('label') {
                              <div class="control-label font-weight-bold">
                                @if (field.type == undefined) {
                                  <label style="font-weight: 500 !important;"
                                  [controlName]="field.name"></label>
                                }
                                @if (field.type === 'datetime') {
                                  <span>
                                    {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateTimeFormat) : ''}}
                                  </span>
                                }
                                @if (field.type === 'date') {
                                  <span>
                                    {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | dateFormat) : ''}}
                                  </span>
                                }
                                @if (field.type === 'time') {
                                  <span>
                                    {{ getFormattedValue(i, field) ? (getFormattedValue(i, field) | timeFormat) : ''}}
                                  </span>
                                }
                              </div>
                            }
                            @case ('numberbox') {
                              <input type="number" [formControlName]="field.name"
                                [min]="0" class="form-control" [attr.step]="0" scrollOverlay>
                            }
                            @case ('textarea') {
                              <textarea [formControlName]="field.name"
                              class="form-control" rows="2"></textarea>
                            }
                            @case ('dropdown') {
                              <select [formControlName]="field.name"
                                (change)="onDropDownChange($event, field, i)" class="form-control"
                                width="150px">
                                <option value="">Select</option>
                                @if (field.options) {
                                  @for (option of field.options; track option) {
                                    <option
                                      [value]="field.getterKey ? getIdKey(option,field) : option.id">
                                      {{ field.getterValue ? getValue(option,field) : option.value }}
                                    </option>
                                  }
                                }
                              </select>
                            }
                            @case ('timepicker') {
                              <dhs-timepicker [formControlName]="field.name"
                                [timePickerSeconds]="field.timePickerSeconds"
                                [timePicker24Hour]="field.timePicker24Hour"
                                [timePickerIncrement]="field.timePickerIncrement" [value]="field.value">
                              </dhs-timepicker>
                            }
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                <div class="_common-card-expand-collapse" (click)="commonCardLayout.classList.toggle('h-full')">
                  <img src="assets/images/icon-expand.svg" class="_card-expand" loading="lazy" alt="">
                </div>
              </div>
            </div>
          }
        </div>
      }
    </form>
  }
</div>